/* Densum — reveals al hacer scroll y barra de compra fija */
(function () {
  var io = null;

  function initReveal(root) {
    var els = (root || document).querySelectorAll('.dn-reveal:not(.dn-in)');
    if (!els.length) return;
    if (!('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('dn-in'); });
      return;
    }
    if (!io) {
      io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) { e.target.classList.add('dn-in'); io.unobserve(e.target); }
        });
      }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    }
    els.forEach(function (el) { io.observe(el); });
  }

  function initSticky() {
    var bar = document.querySelector('.dn-sticky');
    if (!bar || bar.dataset.ready) return;
    bar.dataset.ready = '1';
    var hero = document.querySelector('.dn-hero');
    var rutina = document.getElementById('rutina');
    function update() {
      var heroBottom = hero ? hero.getBoundingClientRect().bottom : 300;
      var onRutina = false;
      if (rutina) {
        var r = rutina.getBoundingClientRect();
        onRutina = r.top < window.innerHeight * 0.6 && r.bottom > 0;
      }
      bar.classList.toggle('dn-sticky--on', heroBottom < 0 && !onRutina);
    }
    var ticking = false;
    window.addEventListener('scroll', function () {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(function () { update(); ticking = false; });
    }, { passive: true });
    update();
  }

  function init() { initReveal(); initSticky(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();

  document.addEventListener('shopify:section:load', function (e) { initReveal(e.target); initSticky(); });
})();
